<mat-toolbar color="accent">Send MOH Enrolment Form</mat-toolbar>

<div class="grid min-h-[80vh] grid-cols-4">
  <div class="col-span-1 flex h-full flex-col gap-4 p-4">
    <span class="text-lg font-bold opacity-80">Complete Form Submission</span>

    <pr-information-box>
      Review and confirm the submission details and email to Ministry of Health.
      If manual changes are required, download the PDF and reupload.
    </pr-information-box>

    <form class="flex flex-col gap-4" [formGroup]="form">
      <pt-signature-input
        label="Agreement Holder's Signature"
        formControlName="agreementHolderSignature"
      />

      <div class="flex flex-col gap-1">
        <span>Patient/Guardian's Signature</span>
        <button
          *ngrxLet="hasPatientSignature$ as hasSignature"
          mat-flat-button
          color="primary"
          class="w-full"
          [disabled]="hasSignature"
          (click)="getPatientSignature()"
        >
          {{
            hasSignature
              ? 'Signed by Patient/Guardian'
              : 'Get Patient/Guardian Signature'
          }}
        </button>
      </div>
    </form>

    <div class="flex-1"></div>

    <pt-buttons-container class="self-end">
      <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="submit()"
      >
        Send Forms
      </button>
    </pt-buttons-container>
  </div>

  <div
    class="col-span-3 flex flex-col border border-solid border-gray-300 bg-gray-100 p-3"
  >
    <pr-moh-form-viewer [forms]="[formDisplay]" [immutable]="false" />
  </div>
</div>
